import { render, staticRenderFns } from "./ZonePostalCodeDetails.vue?vue&type=template&id=4999e395&"
import script from "./ZonePostalCodeDetails.vue?vue&type=script&lang=js&"
export * from "./ZonePostalCodeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports